import h from "react";
import l from "../../../tiny-invariant/dist/esm/tiny-invariant.js";
import { Shape as O } from "./ActiveShapeUtils.js";
var d = ["x", "y"];
function a(e) {
  "@babel/helpers - typeof";
  return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, a(e);
}
function c() {
  return c = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, c.apply(this, arguments);
}
function b(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function u(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? b(Object(n), !0).forEach(function(r) {
      P(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function P(e, t, n) {
  return t = j(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function j(e) {
  var t = w(e, "string");
  return a(t) == "symbol" ? t : t + "";
}
function w(e, t) {
  if (a(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (a(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function S(e, t) {
  if (e == null) return {};
  var n = x(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function x(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function _(e, t) {
  var n = e.x, r = e.y, i = S(e, d), o = "".concat(n), f = parseInt(o, 10), y = "".concat(r), p = parseInt(y, 10), s = "".concat(t.height || i.height), m = parseInt(s, 10), v = "".concat(t.width || i.width), g = parseInt(v, 10);
  return u(u(u(u(u({}, t), i), f ? {
    x: f
  } : {}), p ? {
    y: p
  } : {}), {}, {
    height: m,
    width: g,
    name: t.name,
    radius: t.radius
  });
}
function I(e) {
  return /* @__PURE__ */ h.createElement(O, c({
    shapeType: "rectangle",
    propTransformer: _,
    activeClassName: "recharts-active-bar"
  }, e));
}
var N = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(r, i) {
    if (typeof t == "number") return t;
    var o = typeof r == "number";
    return o ? t(r, i) : (o || (process.env.NODE_ENV !== "production" ? l(!1, "minPointSize callback function received a value with type of ".concat(a(r), ". Currently only numbers are supported.")) : l()), n);
  };
};
export {
  I as BarRectangle,
  N as minPointSizeCallback
};
